// Use this for Local Development
// export const WEBSITE_URL = "http://127.0.0.1/foodomaa";
// export const WEBSITE_URL = "https://demo.portaldigitalpr.com";
// export const WEBSITE_URL = "https://monchies.app";

// Comment out the above and Uncomment the below line before building the files for Production
export const WEBSITE_URL = "https://" + window.location.hostname;
